(ns app.front.view.user-management.state
  "The UI state of a user management view, kept per scope so the tenant and
  group views never share it: `[:tenant tenant-id]` or `[:group group-id]`, and
  for the tenant's row editors `[:tenant tenant-id parent-group-id]`.
  A user's draft exists only once something in their editor has changed, so
  dropping it is what Cancel and a successful save do."
  (:require [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  (fn [db [_ scope]]
    (get-in db [::state scope])))

;; ---------------------------------------------------------------------------
;; Search
;; ---------------------------------------------------------------------------

(rf/reg-event-db ::set-query
  (fn [db [_ scope query]]
    (assoc-in db [::state scope :query] query)))

(rf/reg-sub ::query
  (fn [[_ scope]] (rf/subscribe [::state scope]))
  :-> :query)

;; ---------------------------------------------------------------------------
;; Row editors
;; ---------------------------------------------------------------------------

(rf/reg-event-db ::update-draft
  ;; `original` is where a user's first change starts from.
  (fn [db [_ scope user-id original f & args]]
    (update-in db [::state scope :drafts user-id] #(apply f (or % original) args))))

(rf/reg-event-db ::discard-draft
  (fn [db [_ scope user-id]]
    (update-in db [::state scope :drafts] dissoc user-id)))

(rf/reg-sub ::draft
  (fn [[_ scope]] (rf/subscribe [::state scope]))
  (fn [state [_ _ user-id]]
    (get-in state [:drafts user-id])))

;; ---------------------------------------------------------------------------
;; Add user / add service account forms
;; ---------------------------------------------------------------------------

(rf/reg-event-db ::open-add-form
  (fn [db [_ scope form]]
    (assoc-in db [::state scope :add-form] (assoc form :group-ids #{}))))

(rf/reg-event-db ::update-add-form
  (fn [db [_ scope f & args]]
    (apply update-in db [::state scope :add-form] f args)))

(rf/reg-event-db ::close-add-form
  (fn [db [_ scope]]
    (update-in db [::state scope] dissoc :add-form)))

(rf/reg-sub ::add-form
  (fn [[_ scope]] (rf/subscribe [::state scope]))
  :-> :add-form)

;; ---------------------------------------------------------------------------
;; A new API key: its secret is only ever returned once, so it stays here
;; until the admin dismisses it.
;; ---------------------------------------------------------------------------

(rf/reg-event-db ::show-new-api-key
  (fn [db [_ scope api-key]]
    (assoc-in db [::state scope :new-api-key] api-key)))

(rf/reg-event-db ::dismiss-new-api-key
  (fn [db [_ scope]]
    (update-in db [::state scope] dissoc :new-api-key)))

(rf/reg-sub ::new-api-key
  (fn [[_ scope]] (rf/subscribe [::state scope]))
  :-> :new-api-key)
